/* eslint-disable jsx-a11y/label-has-for */
import PropTypes from 'prop-types';

import './styles/index.css';

/**
 * Order Detail Snapshot
 * Display title and value
 * @param {object} props Incoming props
 * @returns {*} Rendered component
 */
const ListSnapshot = ({
  details,
  rowCount,
  firstRowValueClass,
  otherRowValueClass,
  labelColor,
  listRowClass,
  labelClass,
  isPricingPermission
}) => {
  const orderDetailContent = [];
  let rowBuilder = [];
  details.forEach((detail, index) => {
    if ((detail.isPricingField && isPricingPermission) || !detail.isPricingField) {
      rowBuilder.push(
        <div key={index} className="customer-group">
          <label
            htmlFor={detail.label}
            className={`${labelClass} b order-label list-label order-label__${labelColor} `}
          >
            {detail.label}
          </label>
          <p className={`order-value list-value  ${rowCount > index ? firstRowValueClass : otherRowValueClass} b`}>
            {detail.value}
          </p>
        </div>
      );
    }
    if ((index + 1) % rowCount === 0 || details.length - 1 === index) {
      orderDetailContent.push(
        <div className={`order-info__row list-row ${listRowClass}`} key={index}>
          {rowBuilder}
        </div>
      );
      rowBuilder = [];
    }
  });
  return orderDetailContent;
};

/**
 * @property propTypes
 * @description Defined property types for component
 * @type {{details:*, rowCount:*, firstRowValueClass:*, otherRowValueClass:*, labelColor:*}}
 */
ListSnapshot.propTypes = {
  details: PropTypes.instanceOf(Array),
  rowCount: PropTypes.number,
  isPricingPermission: PropTypes.bool,
  firstRowValueClass: PropTypes.string,
  otherRowValueClass: PropTypes.string,
  labelColor: PropTypes.string,
  listRowClass: PropTypes.string,
  labelClass: PropTypes.string
};

/**
 * @property defaultProps
 * @type {{details: Array, rowCount: number, firstRowValueClass: string, otherRowValueClass: string, labelColor:string}}
 */
ListSnapshot.defaultProps = {
  details: [],
  rowCount: 4,
  isPricingPermission: false,
  firstRowValueClass: 'gamma',
  otherRowValueClass: 'eta',
  labelColor: 'light', // dark, light, medium
  listRowClass: '',
  labelClass: 'eta'
};
export default ListSnapshot;
